const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '标段信息',
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '标段',
            data: [],
        },
    },
]

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.getBaseInfo()
        },
        // TO-DO 这里接口文档没有给字段描述，所以这里是按照pc端代码来写的
        getBaseInfo() {
            this.$request.post(`/transformToAfter/app/contract/record/getYswjInfo`, {
                bdGuid: this.form.bdGuid,
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '公告名称': res.data.ggName,
                    '项目名称': res.data.projectName,
                }
                this.config[5].options.data = res.data.bdList.map((t) => ({
                    '标段/包名称': t.bdName,
                    '标段/包编号': t.bdBH,
                }))
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
